'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _forOwn2 = require('lodash/forOwn');

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _keys2 = require('lodash/keys');

var _keys3 = _interopRequireDefault(_keys2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _differenceWith2 = require('lodash/differenceWith');

var _differenceWith3 = _interopRequireDefault(_differenceWith2);

var _groupBy2 = require('lodash/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _indexOf2 = require('lodash/indexOf');

var _indexOf3 = _interopRequireDefault(_indexOf2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var fixOrder = function fixOrder() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$idField = _ref.idField,
      idField = _ref$idField === undefined ? 'id' : _ref$idField,
      _ref$parentField = _ref.parentField,
      parentField = _ref$parentField === undefined ? 'parent' : _ref$parentField;

  return function (rows) {
    if ((0, _isEmpty3.default)(rows)) {
      return rows;
    }

    // collect all IDs from rows so we can validate parent IDs
    var existingIds = rows.reduce(function (ids, row) {
      if (!(0, _isNil3.default)(row[idField])) {
        ids.push(row[idField]);
      }
      return ids;
    }, []);

    // collect all rows which are children,
    // meaning they have "parent" property and it points to existing row
    var children = rows.filter(function (x) {
      var hasParentId = !(0, _isNil3.default)(x[parentField]);
      var parentExists = hasParentId && (0, _indexOf3.default)(existingIds, x[parentField]) !== -1;
      return hasParentId && parentExists;
    });

    if (!children.length) {
      return rows;
    }

    // groups all children per parent into a object,
    // which looks like that:
    // { parent_id1 : [children of parent id1], parent_id2: [... ] }
    var childrenPerParent = (0, _groupBy3.default)(children, function (x) {
      return x[parentField];
    });

    // removes all children from rows so we can start putting them
    // into right place
    var rowsWithoutChildren = (0, _differenceWith3.default)(rows, children, _isEqual3.default);
    var childrenCount = (0, _keys3.default)(childrenPerParent).length;
    var prevChildrenCount = void 0;
    do {
      prevChildrenCount = childrenCount;
      childrenPerParent = attachChildren(rowsWithoutChildren, childrenPerParent, idField);
      childrenCount = (0, _keys3.default)(childrenPerParent).length;
    } while (childrenCount < prevChildrenCount);

    return rowsWithoutChildren;
  };
};

function attachChildren(rowsWithoutChildren, childrenPerParent, idField) {
  var remainingChildrenPerParent = childrenPerParent;
  (0, _forOwn3.default)(childrenPerParent, function (childrenFromParent, parentId) {
    var parentPosition = (0, _findIndex3.default)(rowsWithoutChildren, function (x) {
      var hasId = !(0, _isNil3.default)(x[idField]);
      var matchesParentId = hasId && parentId === x[idField].toString();
      return hasId && matchesParentId;
    });
    // puts children right after their parent so correct order will be kept
    if (parentPosition !== -1) {
      rowsWithoutChildren.splice.apply(rowsWithoutChildren, [parentPosition + 1, 0].concat(_toConsumableArray(childrenFromParent)));
      delete remainingChildrenPerParent[parentId];
    }
  });
  return remainingChildrenPerParent;
}

exports.default = fixOrder;